import { createAction, props } from '@ngrx/store';

export const FORM_MEDICAL_HISTORY = createAction('[FORMS] :: Mostrar select de historial medico.', props<{ show: boolean }>());
export const FORM_MEDICAL_HISTORY_ID = createAction('[FORMS] :: Id del historial medico.', props<{ id: number }>());
export const FORM_MEDICAL_DATE_ID = createAction('[FORMS] :: Id de la cita medica.', props<{ id: number }>());
export const FORM_MEDICAL_EDIT = createAction('[FORMS] :: Editar historial medico.', props<{ edit: boolean }>());

export const FORM_RESET = createAction('[FORMS] :: Reset formulario.');
